// Blokace slevového kupónu při platbě Edenred karta (objednávka krok-1 a krok-2)
(function () {
    const EDENRED_CONFIG = {
        // value inputu input[name=billingId] platby „Edenred karta"
        billingId: "197",
        // název platby v rekapitulaci na krok-2 (tam ID platby v HTML není), když ho nejde převzít z krok-1
        billingName: "Edenred karta",
        // Shoptetí popisek řádku kupónu v rekapitulaci (bez samotného kódu), podle kterého se pozná dárkový poukaz – ten se neblokuje
        giftVoucherPattern: /poukaz/i,
        // ochranná doba po otevření dialogu, kdy klik mimo okno nezavírá (dvojklik na platbu)
        overlayGuardMs: 400,
        // odebrání kupónu = stejný požadavek jako křížek u kupónu v košíku
        removeCouponUrl: "/action/Cart/deleteCartItem/",
        couponItemTypeId: "6",
        step1Url: "/objednavka/krok-1/",
        texts: {
            heading: "Slevový kód nelze kombinovat s platbou Edenred",
            text: "Kartou Edenred nelze platit objednávku se slevovým kódem. Můžete slevový kód odebrat a zaplatit kartou Edenred, nebo si zvolit jinou platbu a slevu si ponechat.",
            removeButton: "Odebrat slevový kód",
            otherButton: "Zvolit jinou platbu",
            removeError: "Slevový kód se nepodařilo odebrat. Zkuste to prosím znovu, nebo ho odeberte v košíku.",
            removedMessage: "Slevový kód byl odebrán. Objednávku teď můžete dokončit.",
            removedNoSummary: "Slevový kód byl odebrán. Souhrn objednávky se aktualizuje po obnovení stránky.",
        },
    };

    const STORAGE_RESTORE = "myedenred-restore";
    const STORAGE_NAME = "myedenred-name";

    const isStep1 = !!document.body && document.body.classList.contains("id--16");
    const isStep2 = !!document.body && document.body.classList.contains("id--17");

    if ((!isStep1 && !isStep2) || typeof shoptet === "undefined" || typeof getShoptetDataLayer !== "function" || typeof jQuery === "undefined") {
        return;
    }

    const $ = jQuery;
    const state = {
        currentBilling: undefined,
        previousBilling: null,
        removedCode: null,
        dialogOpen: false,
        closedByAction: false,
        busy: false,
        pendingMessage: null,
        openedAt: 0,
    };

    // Kupón v košíku: cartInfo.discountCoupon je objekt { code, id }, bez kupónu prázdné pole
    function getCouponCode() {
        const cartInfo = getShoptetDataLayer("cartInfo");
        let coupon = cartInfo ? cartInfo.discountCoupon : null;

        if (Array.isArray(coupon)) {
            coupon = coupon[0];
        }

        if (!coupon || !coupon.code || coupon.code === state.removedCode) {
            return null;
        }

        return String(coupon.code);
    }

    function getCouponRow(code) {
        return $("#summary-box .recapitulation-single").filter(function () {
            return $(this).text().indexOf(code) !== -1;
        }).first();
    }

    // Blokuje se jen slevový kupón; řádek s dárkovým poukazem projde
    function hasBlockedCoupon() {
        const code = getCouponCode();

        if (!code) {
            return false;
        }

        const $row = getCouponRow(code);

        const label = $row.text().split(code).join(" ");

        return !($row.length && EDENRED_CONFIG.giftVoucherPattern.test(label));
    }

    function getCheckedBilling() {
        const input = document.querySelector("#order-billing-methods input[name='billingId']:checked");

        return input ? input.value : null;
    }

    function isEdenredSelected() {
        if (isStep1) {
            return getCheckedBilling() === EDENRED_CONFIG.billingId;
        }

        const name = sessionStorage.getItem(STORAGE_NAME) || EDENRED_CONFIG.billingName;
        let selected = false;

        $("#summary-box .recapitulation-single").each(function () {
            const $label = $(this).children("span").first();
            const $payment = $(this).find("[data-testid='recapPaymentMethod']");

            if (!$label.length || !$payment.length) {
                return;
            }

            const paymentName = $payment.clone().children("[data-testid='recapItemPrice']").remove().end().text().trim();

            if (paymentName === name) {
                selected = true;
            }
        });

        return selected;
    }

    function isBlocked() {
        return isEdenredSelected() && hasBlockedCoupon();
    }

    function getWrapper(id) {
        return $("#order-billing-methods input[name='billingId'][value='" + id + "']").closest(".radio-wrapper");
    }

    // Výběr platby stejnou cestou jako klik zákazníka (Shoptet reaguje na mousedown)
    function selectMethod($wrapper) {
        if ($wrapper.length) {
            $wrapper[0].dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
        }
    }

    function deselectEdenred() {
        const $wrapper = getWrapper(EDENRED_CONFIG.billingId);
        const billingType = $("#order-billing-methods").attr("data-type");
        const shippingId = ($("#order-shipping-methods .radio-wrapper.active").attr("data-id") || "").replace("shipping-", "");

        $wrapper.find("input[name='billingId']").prop("checked", false);
        $wrapper.removeClass("active");
        $wrapper.find("label").removeClass("active");
        shoptet.checkoutShared.activeBilling = null;

        $("#shipping-billing-summary .recapitulation-shipping-billing").filter(function () {
            return $(this).find(".recapitulation-shipping-billing-label").text().trim() === billingType + ":";
        }).remove();

        if (shippingId) {
            shoptet.checkoutShared.updatePriceSummary(shippingId, "");
        }

        state.currentBilling = null;
    }

    function chooseOtherPayment() {
        if (isStep2) {
            window.location.href = EDENRED_CONFIG.step1Url;
            return;
        }

        if (getCheckedBilling() !== EDENRED_CONFIG.billingId) {
            return;
        }

        let $focus;

        if (state.previousBilling && state.previousBilling !== EDENRED_CONFIG.billingId && getWrapper(state.previousBilling).length) {
            selectMethod(getWrapper(state.previousBilling));
            $focus = getWrapper(state.previousBilling).find("input[name='billingId']");
        } else {
            deselectEdenred();
            $focus = $("#order-billing-methods input[name='billingId']:not(:disabled)").first();
        }

        $focus.trigger("focus");
    }

    function removeCoupon(code) {
        const formData = new FormData();

        formData.append("itemTypeId", EDENRED_CONFIG.couponItemTypeId);
        formData.append("internalCode", code);
        formData.append("__csrf__", shoptet.csrf.token);

        return fetch(EDENRED_CONFIG.removeCouponUrl, {
            method: "POST",
            body: formData,
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        }).then(function (response) {
            if (!response.ok) {
                throw new Error("HTTP " + response.status);
            }

            return response.json();
        }).then(function (data) {
            let coupon = data && data.payload ? data.payload.discountCoupon : undefined;

            if (Array.isArray(coupon)) {
                coupon = coupon.length ? coupon[0] : null;
            }

            if (coupon === undefined || (coupon && coupon.code === code)) {
                throw new Error("coupon still applied");
            }

            state.removedCode = code;
        });
    }

    // Krok-1: před přenačtením si zapamatovat dopravu (vč. odběrného místa), po něm vrátit i s Edenredem
    function saveSelection() {
        const $shipping = $("#order-shipping-methods .radio-wrapper.active");
        const $branch = $shipping.find("input[name^='shippingMethodBranch']");
        const $branchLabel = $shipping.find(".new-gen-choose, .new-widget-choose").first();

        sessionStorage.setItem(STORAGE_RESTORE, JSON.stringify({
            shipping: $shipping.attr("data-id") || null,
            branchValue: $branch.length ? $branch.val() : null,
            branchHtml: $branch.length && $branch.val() ? $branchLabel.html() : null,
            billing: EDENRED_CONFIG.billingId,
            time: Date.now(),
        }));
    }

    function restoreSelection() {
        let saved = null;

        try {
            saved = JSON.parse(sessionStorage.getItem(STORAGE_RESTORE));
        } catch (e) {
            saved = null;
        }

        sessionStorage.removeItem(STORAGE_RESTORE);

        if (!saved || Date.now() - saved.time > 60000) {
            return;
        }

        const $shipping = $("#order-shipping-methods .radio-wrapper[data-id='" + saved.shipping + "']");

        if ($shipping.length && !$shipping.find("label").hasClass("inactive")) {
            if (saved.branchValue) {
                $shipping.find("input[name^='shippingMethodBranch']").val(saved.branchValue);

                if (saved.branchHtml) {
                    $shipping.find(".new-gen-choose, .new-widget-choose").first().html(saved.branchHtml);
                }
            }

            selectMethod($shipping);
        }

        const $billing = getWrapper(saved.billing);

        if ($billing.length && !$billing.find("label").hasClass("inactive")) {
            selectMethod($billing);
        }
    }

    // Krok-2: rekapitulaci po odebrání kupónu načíst ze serveru, vyplněný formulář zůstane
    function refreshStep2Summary(code) {
        return fetch(window.location.pathname, { credentials: "same-origin" }).then(function (response) {
            return response.text();
        }).then(function (html) {
            const doc = shoptet.common.createDocumentFromString(html);
            const freshSummary = doc.querySelector("#summary-box");

            if (!freshSummary) {
                throw new Error("summary missing");
            }

            $("#summary-box").replaceWith(freshSummary);
        });
    }

    function onRemoveClick() {
        const code = getCouponCode();

        if (state.busy) {
            return;
        }

        if (!code) {
            closeDialog(true);
            return;
        }

        state.busy = true;
        $(".myedenred-button").prop("disabled", true);

        removeCoupon(code).then(function () {
            if (isStep1) {
                saveSelection();
                window.location.reload();
                return;
            }

            // Kupón je podle odpovědi Shoptetu pryč; selhat může už jen překreslení souhrnu
            return refreshStep2Summary(code).then(function () {
                return EDENRED_CONFIG.texts.removedMessage;
            }, function () {
                return EDENRED_CONFIG.texts.removedNoSummary;
            }).then(function (message) {
                state.busy = false;
                state.pendingMessage = message;
                closeDialog(true);
            });
        }).catch(function () {
            state.busy = false;
            $(".myedenred-button").prop("disabled", false);
            $(".myedenred-error").removeClass("no-display").text(EDENRED_CONFIG.texts.removeError);
        });
    }

    function closeDialog(byAction) {
        state.closedByAction = byAction;
        shoptet.modal.close();
    }

    function openDialog() {
        if (state.dialogOpen) {
            return;
        }

        const texts = EDENRED_CONFIG.texts;

        state.dialogOpen = true;
        state.closedByAction = false;
        state.openedAt = Date.now();

        shoptet.modal.open({
            html: "<div class='myedenred colorbox-html-content' role='alertdialog' aria-labelledby='myedenred-heading' aria-describedby='myedenred-text'>" +
                "<h2 class='myedenred-heading h4' id='myedenred-heading'>" + texts.heading + "</h2>" +
                "<p class='myedenred-text' id='myedenred-text'>" + texts.text + "</p>" +
                "<p class='myedenred-error no-display' role='alert'></p>" +
                "<div class='myedenred-actions'>" +
                    "<button type='button' class='btn btn-primary myedenred-button myedenred-remove'>" + texts.removeButton + "</button>" +
                    "<button type='button' class='btn btn-secondary myedenred-button myedenred-other'>" + texts.otherButton + "</button>" +
                "</div>" +
            "</div>",
            width: shoptet.modal.config.widthSm,
            className: shoptet.modal.config.classSm + " myedenred-modal",
            overlayClose: false,
            escKey: true,
            returnFocus: !isStep1,
            onComplete: function () {
                shoptet.modal.shoptetResize();
                $(".myedenred-remove").trigger("focus");
            },
            onClosed: function () {
                state.dialogOpen = false;

                if (state.pendingMessage) {
                    showMessage(state.pendingMessage, "success", "", false, false);
                    state.pendingMessage = null;
                }

                // Křížek, Esc nebo klik mimo = jako „Zvolit jinou platbu" (na krok-2 jen zavřít)
                if (isStep1 && !state.busy && !state.closedByAction) {
                    chooseOtherPayment();
                }
            },
        });
    }

    // Klik mimo okno zavírá až po ochranné době – druhý klik dvojkliku na platbu trefí overlay
    $(document).on("click", "#cboxOverlay", function () {
        if (state.dialogOpen && !state.busy && Date.now() - state.openedAt > EDENRED_CONFIG.overlayGuardMs) {
            shoptet.modal.close();
        }
    });

    $(document).on("click", ".myedenred-remove", function () {
        onRemoveClick();
    });

    $(document).on("click", ".myedenred-other", function () {
        closeDialog(true);
        chooseOtherPayment();
    });

    if (isStep1) {
        const edenredName = getWrapper(EDENRED_CONFIG.billingId).find(".shipping-billing-name").first().text().trim();

        if (edenredName) {
            sessionStorage.setItem(STORAGE_NAME, edenredName);
        }

        function onBillingChange() {
            const billing = getCheckedBilling();

            if (billing === state.currentBilling) {
                return;
            }

            if (state.currentBilling === undefined) {
                state.currentBilling = billing;
                return;
            }

            if (billing === EDENRED_CONFIG.billingId && hasBlockedCoupon()) {
                state.previousBilling = state.currentBilling;
                state.currentBilling = billing;
                openDialog();
                return;
            }

            state.currentBilling = billing;
        }

        document.addEventListener("ShoptetBillingMethodUpdated", onBillingChange);
        $(document).on("change", "#order-billing-methods input[name='billingId']", onBillingChange);

        // Pojistka: pokračovat dál s Edenredem a kupónem nejde (i když zůstal vybraný po návratu)
        function guardContinue(e) {
            if (!isBlocked()) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            if (state.currentBilling !== EDENRED_CONFIG.billingId) {
                state.previousBilling = null;
                state.currentBilling = EDENRED_CONFIG.billingId;
            }

            openDialog();
        }

        document.addEventListener("click", function (e) {
            if (e.target.closest && e.target.closest("#orderFormButton, .js-orderFormSubmit")) {
                guardContinue(e);
            }
        }, true);

        document.addEventListener("submit", function (e) {
            if (e.target.id === "order-form") {
                guardContinue(e);
            }
        }, true);

        document.addEventListener("DOMContentLoaded", function () {
            if (state.currentBilling === undefined) {
                state.currentBilling = getCheckedBilling();
            }

            restoreSelection();
        });
    }

    if (isStep2 && shoptet.scripts && typeof shoptet.scripts.setCustomFunction === "function") {
        // Pojistka před odesláním objednávky: false zastaví odeslání formuláře
        shoptet.scripts.setCustomFunction("postSuccessfulValidation", function (form) {
            if (form && form.id === "order-form" && isBlocked()) {
                openDialog();
                return false;
            }

            return true;
        });
    }
})();
